import TitleBorderLeft from "../../components/Text/TitleBorderLeft"
import frameworkPageData from "../../data/english/subpages/framework-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const InternationalFrameworkPage = () => {
  return (
    <main className="page" id="main">
    <div className="sticky-view-two">
    <div className="sticky-container">
      <MainHeader 
        image={{
          src : require(`../../assets/images/wallpaper/${frameworkPageData.headerImage.name}`),
          alt : frameworkPageData.headerImage.alt,
        }}
        title=""
      />
    </div>
    <div className="sticky-container-two">
        <div className="wrapper-small">
          <h1 className="title-center">{frameworkPageData.mainTitle}</h1>
          <section>
            <img 
              src={require(`../../assets/images/companies/unep.png`)} 
              alt={frameworkPageData.sectionOne.icon.alt} 
              className="organisation-image"
            />
            <TitleBorderLeft>{frameworkPageData.sectionOne.title}</TitleBorderLeft>
            <p className="text-paragraph">{frameworkPageData.sectionOne.paragraphOne}</p>
            <p className="text-paragraph">{frameworkPageData.sectionOne.paragraphTwo}</p>
            <p className="text-paragraph">{frameworkPageData.sectionOne.paragraphThree}</p>
          </section>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <section>
            <img 
              src={require(`../../assets/images/companies/united-nations.png`)} 
              alt={frameworkPageData.sectionOne.icon.alt} 
              className="organisation-image"
            />
            <TitleBorderLeft>{frameworkPageData.sectionTwo.title}</TitleBorderLeft>
            <p className="text-paragraph">{frameworkPageData.sectionTwo.paragraphOne}</p>
          </section>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <section>
            <img 
              src={require(`../../assets/images/companies/sabb-standards.png`)} 
              alt={frameworkPageData.sectionOne.icon.alt} 
              className="organisation-image"
            />
            <TitleBorderLeft>{frameworkPageData.sectionThree.title}</TitleBorderLeft>
            <p className="text-paragraph">{frameworkPageData.sectionThree.paragraphOne}</p>
            <p className="text-paragraph">{frameworkPageData.sectionThree.paragraphTwo}</p>
          </section>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <section>
            {/* <img 
              src={require(`../../assets/images/companies/sabb-standards.png`)} 
              alt={frameworkPageData.sectionOne.icon.alt} 
              className="organisation-image"
            /> */}
            <TitleBorderLeft>{frameworkPageData.sectionFour.title}</TitleBorderLeft>
            <p className="text-paragraph">{frameworkPageData.sectionFour.paragraphOne}</p>
            {/* <p className="text-paragraph">{frameworkPageData.sectionFour.paragraphTwo}</p> */}
          </section>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
        </div>
      <Footer withBlogs={false} />
    </div>
    </div>
    </main>
  )
}

export default InternationalFrameworkPage